// extracted by mini-css-extract-plugin
export var wrapper = "GradientBg-module--wrapper--79nFs";